import React from 'react';

import './Briefing.css';

const Briefing = ({
  createBriefingClick,
  allBriefings,
  handleDeleteBriefing,
  onBrifingClick,
}) => {
  const handleWriteStoryClick = (briefing: any = null) => {
    createBriefingClick(briefing);
  };

  return (
    <div>
      <div className='header-container'>
        <h2
          style={{
            color: '#161616',
            fontSize: 24,
            fontFamily: 'Nunito Sans',
            fontWeight: 700,
          }}
        >
          Briefing
        </h2>
        <button
          className='Create-a-Briefing'
          onClick={() => handleWriteStoryClick()}
        >
          Create a Briefing
        </button>
      </div>
      <table>
        <thead>
          <tr
            style={{
              color: '#667085',
              fontSize: 14,
              fontFamily: 'Nunito Sans',
              fontWeight: 400,
            }}
          >
            <th>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span> Title</span>
                <img
                  src='./assets/arrowdown.svg'
                  alt='arrowDown'
                  style={{
                    marginLeft: 5,
                  }}
                />
              </div>
            </th>
            <th>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>Creation Date</span>
                <img
                  src='./assets/arrowdown.svg'
                  alt='arrowDown'
                  style={{
                    marginLeft: 5,
                  }}
                />
              </div>
            </th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody style={{ marginTop: 10 }}>
          {allBriefings.map((briefing: any) => {
            const isEditable = briefing.status?.toUpperCase() !== 'PUBLISHED';
            return (
              <tr key={briefing.id}>
                <td
                  style={{
                    color: '#161616',
                    fontSize: 14,
                    fontFamily: 'Nunito Sans',
                    fontWeight: 700,
                    cursor: 'pointer',
                  }}
                  onClick={
                    isEditable ? onBrifingClick.bind(this, briefing) : null
                  }
                >
                  {briefing.title}
                </td>
                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontFamily: 'Nunito Sans',
                    fontWeight: 400,
                  }}
                >
                  {new Date(briefing.createdAt._seconds * 1000).toUTCString()}
                </td>

                <td
                  style={{
                    color: '#667085',
                    fontSize: 14,
                    fontFamily: 'Nunito Sans',
                    fontWeight: 400,
                  }}
                >
                  {briefing.status?.toUpperCase()}
                </td>
                {isEditable && (
                  <td>
                    <span
                      onClick={() => {
                        handleWriteStoryClick(briefing);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src='./assets/Edit.svg' alt='edit' />
                    </span>
                    <span
                      onClick={() => {
                        handleDeleteBriefing(briefing);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src='./assets/delete.svg' alt='delete' />
                    </span>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Briefing;
